// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../styles/ui.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* class for the icon and container */
.styles__notificationButton___tpz47 {
  background-color: transparent;
  border: 0px;
}
.styles__notificationsWrap___qrYhg {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  position: relative;
  background-color: #f1f1f1;
  border-radius: 3px;
  border: 1px solid rgba(100, 100, 100, 0.4);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
  width: 400px;
  height: 300px;
  right: -7rem !important;
  left: unset !important;
  padding: 0 !important;
  overflow-y: auto;
}

.styles__dropdownContent___PZBos {
  display: none;
  width: 400px;
  height: 300px;
  position: absolute;
  top: ${___CSS_LOADER_ICSS_IMPORT_1___.locals["headerHeight"]};
  right: 0;
  left: auto;
  background-color: #f1f1f1;
  border-radius: 3px;
  border: 1px solid rgba(100, 100, 100, 0.4);
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
}

.styles__bell___eFwab {
  color: rgba(241, 245, 250, 0.7);
}

.styles__bell___eFwab:hover {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
  }

.styles__bell___eFwab.styles__warn___hEQVi {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.styles__bell___eFwab.styles__warn___hEQVi:hover {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
  }

.styles__bell___eFwab.styles__info___OcPq9 {
  color: lightblue;
}

.styles__bell___eFwab.styles__info___OcPq9:hover {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
  }

.styles__notification___jW8SC {
  background-color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 1rem;
  width: 100%;
}

.styles__notification___jW8SC + .styles__notification___jW8SC {
  margin-top: 5px;
}

.styles__notification___jW8SC.styles__warn___hEQVi .styles__typeIcon____7_wU {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.styles__notificationContent___pTeSe {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.styles__notificationContent___pTeSe > * {
    margin-bottom: 10px;
  }

.styles__notificationContent___pTeSe > *:last-child {
    margin-bottom: 0;
  }

.styles__notificationTools___adXvQ {
  display: flex;
  flex-direction: column;
}

.styles__notificationTools___adXvQ .styles__resolveButton___F1tbC {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
    cursor: pointer;
  }

.styles__notificationTools___adXvQ .styles__resolveButton___F1tbC:hover {
      color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
    }

.styles__notificationTools___adXvQ > * {
    margin-bottom: 5px;
  }

.styles__type___ANQUs {
  text-transform: capitalize;
}

.styles__empty___BOPNM {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  font-weight: bold;
  font-size: 17px;
  text-align: center;
  color: darkgray;
}

.styles__notificationTriggerWrap___u3Tkm {
  height: 100%;
}
`, "",{"version":3,"sources":["webpack://./universal/components/Header/Notification/styles.css"],"names":[],"mappings":"AAKA,qCAAqC;AACrC;EACE,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,wCAAwC;EACxC,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,iDAAiB;EACjB,QAAQ;EACR,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AAKjC;;AAHE;IACE,mDAAkB;EACpB;;AAGF;EACE,mDAAY;AAKd;;AAHE;IACE,mDAAgB;EAClB;;AAGF;EACE,gBAAgB;AAKlB;;AAHE;IACE,mDAAkB;EACpB;;AAGF;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mDAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AASd;;AAPE;IACE,mBAAmB;EACrB;;AAEA;IACE,gBAAgB;EAClB;;AAGF;EACE,aAAa;EACb,sBAAsB;AAcxB;;AAZE;IACE,mDAAa;IACb,eAAe;EAKjB;;AAHE;MACE,mDAAiB;IACnB;;AAGF;IACE,kBAAkB;EACpB;;AAGF;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd","sourcesContent":["@value colors: 'styles/colors.css';\n@value gtRed, gtRedDark, gtGreen, gtBlue, gtBlueDark, gtBlueLight from colors;\n@value ui: 'styles/ui.css';\n@value headerHeight from ui;\n\n/* class for the icon and container */\n.notificationButton {\n  background-color: transparent;\n  border: 0px;\n}\n.notificationsWrap {\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  height: 100%;\n  position: relative;\n  background-color: #f1f1f1;\n  border-radius: 3px;\n  border: 1px solid rgba(100, 100, 100, 0.4);\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);\n  width: 400px;\n  height: 300px;\n  right: -7rem !important;\n  left: unset !important;\n  padding: 0 !important;\n  overflow-y: auto;\n}\n\n.dropdownContent {\n  display: none;\n  width: 400px;\n  height: 300px;\n  position: absolute;\n  top: headerHeight;\n  right: 0;\n  left: auto;\n  background-color: #f1f1f1;\n  border-radius: 3px;\n  border: 1px solid rgba(100, 100, 100, 0.4);\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.2);\n  overflow-y: auto;\n}\n\n.bell {\n  color: rgba(241, 245, 250, 0.7);\n\n  &:hover {\n    color: gtBlueLight;\n  }\n}\n\n.bell.warn {\n  color: gtRed;\n\n  &:hover {\n    color: gtRedDark;\n  }\n}\n\n.bell.info {\n  color: lightblue;\n\n  &:hover {\n    color: gtBlueLight;\n  }\n}\n\n.notification {\n  background-color: white;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  padding: 1rem;\n  width: 100%;\n}\n\n.notification + .notification {\n  margin-top: 5px;\n}\n\n.notification.warn .typeIcon {\n  color: gtRed;\n}\n\n.notificationContent {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n\n  > * {\n    margin-bottom: 10px;\n  }\n\n  > *:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.notificationTools {\n  display: flex;\n  flex-direction: column;\n\n  .resolveButton {\n    color: gtBlue;\n    cursor: pointer;\n\n    &:hover {\n      color: gtBlueDark;\n    }\n  }\n\n  > * {\n    margin-bottom: 5px;\n  }\n}\n\n.type {\n  text-transform: capitalize;\n}\n\n.empty {\n  display: flex;\n  flex-flow: column nowrap;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  font-weight: bold;\n  font-size: 17px;\n  text-align: center;\n  color: darkgray;\n}\n\n.notificationTriggerWrap {\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `'styles/colors.css'`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtRedDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]}`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"ui": `'styles/ui.css'`,
	"headerHeight": `${___CSS_LOADER_ICSS_IMPORT_1___.locals["headerHeight"]}`,
	"notificationButton": `styles__notificationButton___tpz47`,
	"notificationsWrap": `styles__notificationsWrap___qrYhg`,
	"dropdownContent": `styles__dropdownContent___PZBos`,
	"bell": `styles__bell___eFwab`,
	"warn": `styles__warn___hEQVi`,
	"info": `styles__info___OcPq9`,
	"notification": `styles__notification___jW8SC`,
	"typeIcon": `styles__typeIcon____7_wU`,
	"notificationContent": `styles__notificationContent___pTeSe`,
	"notificationTools": `styles__notificationTools___adXvQ`,
	"resolveButton": `styles__resolveButton___F1tbC`,
	"type": `styles__type___ANQUs`,
	"empty": `styles__empty___BOPNM`,
	"notificationTriggerWrap": `styles__notificationTriggerWrap___u3Tkm`
};
export default ___CSS_LOADER_EXPORT___;
